export default function () {
  return {
    users: [],
  }
}
